import axios from 'axios';

const BASE = '/pedidos/compra';

export default {
  index(params = {}) {
    const { page = 1, rowsPerPage = 10, estado, proveedor, fecha_desde, fecha_hasta, entrega_hasta } = params;
    const query = new URLSearchParams({ page, page_size: rowsPerPage });
    if (estado)        query.set('estado', estado);
    if (proveedor)     query.set('proveedor', proveedor);
    if (fecha_desde)   query.set('fecha_desde', fecha_desde);
    if (fecha_hasta)   query.set('fecha_hasta', fecha_hasta);
    if (entrega_hasta) query.set('entrega_hasta', entrega_hasta);
    return axios.get(`${BASE}?${query}`);
  },

  show(id) {
    return axios.get(`${BASE}/${id}`);
  },

  create(data) {
    return axios.post(BASE, data);
  },

  update(id, data) {
    return axios.put(`${BASE}/${id}`, data);
  },

  destroy(id) {
    return axios.delete(`${BASE}/${id}`);
  },

  cambiarEstado(id, estado) {
    return axios.post(`${BASE}/${id}/estado/${estado}`);
  },

  recibir(id, data) {
    return axios.post(`${BASE}/${id}/recibir`, data);
  },

  clonar(id) {
    return axios.post(`${BASE}/${id}/clonar`);
  },

  enviarEmail(id) {
    return axios.post(`${BASE}/${id}/enviar-email`);
  },

  pdf(id) {
    return axios.get(`${BASE}/${id}/pdf`, { responseType: 'blob' });
  },

  productos() {
    return axios.get(`${BASE}/productos`);
  },
};
